import type { FC } from 'react'
import { Flex, Spin } from '@/components'
import { SC_DocumentContent } from './styled'
import type { T_DocumentResponse } from '@/types/responses'

type T_DocumentContentProps = {
  title: string
  currentDoc?: T_DocumentResponse | null
  isLoading: boolean
}

export const Document: FC<T_DocumentContentProps> = ({
  title,
  currentDoc,
  isLoading,
}) => {
  if (isLoading) {
    return (
      <Flex justify='center' align='center'>
        <Spin size='large' />
      </Flex>
    )
  }

  return (
    <SC_DocumentContent>
      <h2>{title}</h2>
      {currentDoc?.content?.ru ? (
        <div dangerouslySetInnerHTML={{ __html: currentDoc.content.ru }} />
      ) : (
        <p>Контент отсутствует</p>
      )}
    </SC_DocumentContent>
  )
}
